
import React, { useEffect, useState } from 'react';

export const RateCardDistanceActionComponent = ({ selectDisUnit, distanceBaseMax, distanceIncrement, distanceChargePerIncrement }: any) => {
    const [distanceData, setDistanceData] = useState([]);

    const calculateCharges = () => {
        const distances = [];
        let cost = 0;
        for (let i = distanceBaseMax; distances?.length < 3; i += distanceIncrement) {
            if (i > distanceBaseMax) {
                cost += distanceChargePerIncrement;
            }
            distances.push({ distance: i, cost });
        }
        setDistanceData(distances);
    }
    useEffect(() => {
        calculateCharges();
    }, []);
    return (


        <div className="max-w-md mx-auto p-4 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Distance Charges</h2>

            {/* Table for displaying charges */}
            <table className="w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border px-4 py-2">Distance ({selectDisUnit})</th>
                        <th className="border px-4 py-2">Charges (₹)</th>
                    </tr>
                </thead>
                <tbody>
                    {distanceData.map((item, index) => (
                        <tr key={index} className="text-center">
                            <td className="border px-4 py-2">{item.distance} {selectDisUnit}</td>
                            <td className="border px-4 py-2">₹{item.cost}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>


    )
}
export default RateCardDistanceActionComponent;
